function deepClone<T extends object>(original: T): T {
	return JSON.parse(JSON.stringify(original));
}

export { deepClone };
